import * as _ from 'lodash';
import { isFunction, isUndefined } from './utils';
import { GenericTreeNode } from '../components/generic-tree/generic-tree-node';
import { Permissions, PermissionSet, SecureObject, ObjectActionListType, ActionType } from './permission';
export class ContextMenuOption extends SecureObject {
    name: string;
    nameFunction: (item) => string;
    
    visible: boolean | ((item: any) => boolean);
    enabled: boolean | ((item: any) => boolean);
    enabledFunction: ((item: any) => boolean);
    divider: boolean;
    passive: boolean;
    checked: boolean | ((item: any) => boolean);
    click: (item: any) => void;

    iconClass: string;
    iconColor: string;
    iconSecondClass: string;
    iconSecondColor: string;
    secondIconCustomClass: boolean;
    resetFilterClass: boolean;

    tooltip: string;
    tooltipFunction: (item: any) => string;
    tooltipAlwaysOn: boolean;

    automationId: string;
    automationIdFunction: (item: any) => string;

    // set this when need to add also corresponding org settings permission to existing prj settings permission with given action type
    orgPermissionAction?: ActionType;

    isVisible = (item: any) => {
        let visible = isFunction(this.visible) ? Boolean((this.visible as ((item: any) => boolean))(item)) : this.visible;
        if (visible && !item.divider) {
            const permissions = this.getPermissions(item);
            if (permissions && permissions.length > 0) {
                visible = Permissions.checkUserPermissions(permissions, this.atLeastOne);
            }
        }
        return visible;
    }

    getPermissions = (item: any): PermissionSet[] => {
        let permissions = isFunction(this.permissionsGetter) ? this.permissionsGetter(item) : this.permissions;
        if (permissions && permissions.length > 0 && item instanceof GenericTreeNode && item.permissions && item.permissions.length === 1 && item.permissions[0].permissionType) {
            // case for when the menu has dynamic permissions (no permission type) => take type from tree node
            const hasIncompletePermissions = permissions.find(p => !p.permissionType);
            if (hasIncompletePermissions) {
                permissions = _.cloneDeep(this.permissions);
                const orgPermissions = new Array<PermissionSet>();
                permissions.forEach(element => {
                    if (!element.permissionType) {
                        element.permissionType = item.permissions[0].permissionType;
                        if (element.permissionType.startsWith('PRJ_') && this.orgPermissionAction) {
                            orgPermissions.push(new PermissionSet({
                                permissionType: element.permissionType.replace('PRJ_', 'ORG_') as ObjectActionListType,
                                permissionActions: [this.orgPermissionAction]
                            }));
                        }
                    }
                });
                if (orgPermissions.length > 0) {
                    permissions.push(...orgPermissions);
                }
            }
        }
        return permissions;
    }

    constructor(value?: Partial<ContextMenuOption>) {
        super();
        if (value) {
            Object.assign(this, value);
            if (isUndefined(this.click) && !this.divider) {
                this.click = (item: any) => item.onContextMenuAction(item, this.name ? this.name : this.nameFunction(item));
            }
            if (isUndefined(this.visible)) {
                this.visible = true;
            }
            if (isUndefined(this.enabled) && !this.divider) {
                this.enabled = true;
            }
            if (isUndefined(this.nameFunction) && !this.divider) {
                this.nameFunction = () => this.name;
            }
            if (isUndefined(this.tooltipFunction) && !this.divider) {
                this.tooltipFunction = () => this.tooltip;
            }
            this.automationIdFunction = () => this.automationId;
            if (isUndefined(this.automationId)) {
                this.automationIdFunction = (item: any) => {
                    if (this.divider) {
                        return `${item.automationId ? item.automationId + '-' : ''}context-menu-divider`;
                    } else {
                        return `${item.automationId ? item.automationId + '-' : ''}` +
                            `context-menu-${this.nameFunction(item).toLowerCase().replace(' ...', '').replace(new RegExp(' ', 'g'), '-')}`;
                    }
                };
            }
        }
    }
}
